import { createSlice, nanoid, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../../assets/utils/accessToken";
const initialState = {
  ProfessionalExperiences: [],
  ProfessionalExperiencesStatus: "idle",
  ProfessionalExperienceStatus: "idle",
  error: null,
  ProfessionalExperience: null,
};

export const fetchProfessionalExperiencesByPersonId = createAsyncThunk(
  "ProfessionalExperience/fetchProfessionalExperiencesByPersonId",
  async (person_id) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      BaseUrl + `/professionalExperience/byStaff/?staff_id=${person_id}`,
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      }
    );
    console.log(response.data, "response.data of groups");

    return response.data;
  }
);

export const addNewProfessionalExperience = createAsyncThunk(
  "ProfessionalExperience/addNewProfessionalExperience",
  async (body, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(BaseUrl + "/professionalExperience/create/", body, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      console.log(response.data, "response.data of groups");

      return response.data;
    } catch (err) {
      let error = err; // cast the error for access
      if (!error.response) {
        throw err;
      }
      // We got validation errors, let's return those so we can reference in our component and set form errors
      console.log("error.response from inside the CAT", error.response);
      return rejectWithValue(error.response);
    }
  }
);
export const UpdateProfessionalExperience = createAsyncThunk(
  "ProfessionalExperience/UpdateProfessionalExperience",
  async (data, thunkAPI) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.put(
        BaseUrl + `/professionalExperience/${data.id}/edit/`,
        data.modified,
        {
          headers: {
            Authorization: `token ${token}`,
          },
        }
      );
      console.log(data, "education");
      console.log(response.data, "response.data");
      return response.data;
    } catch (error) {
      console.error("Failed to update the education: ", error);
    }
  }
);

export const deleteProfessionalExperience = createAsyncThunk(
  "ProfessionalExperience/deleteProfessionalExperience",
  async (id) => {
    const token = localStorage.getItem("token");
    const response = await axios.delete(BaseUrl + `/professionalExperience/${id}/delete/`, {
      headers: {
        Authorization: `token ${token}`,
      },
    });

    return response.data;
  }
);

const ProfessionalExperienceSlice = createSlice({
  name: "education",
  initialState,
  extraReducers: {
    [fetchProfessionalExperiencesByPersonId.pending]: (state, action) => {
      state.ProfessionalExperiencesStatus = "loading";
    },
    [fetchProfessionalExperiencesByPersonId.fulfilled]: (state, action) => {
      state.TeaProfessionalExperiencesStatus = "succeeded";
      // Add any fetched posts to the array
      state.ProfessionalExperiences = action.payload;
    },
    [fetchProfessionalExperiencesByPersonId.rejected]: (state, action) => {
      state.ProfessionalExperiencesStatus = "failed";
      state.error = action.payload;
    },

    [addNewProfessionalExperience.fulfilled]: (state, action) => {
      // state.groups.push(action.payload);
    },

    [UpdateProfessionalExperience.fulfilled]: (state, action) => {
      // state.groups.push(action.payload);
    },
    [deleteProfessionalExperience.fulfilled]: (state, action) => {},
  },
});

export default ProfessionalExperienceSlice.reducer;
// export const  groups = state => state.group.groups
